<template>
    <center>
        <headful
            title="Caseen - Login"
        />
        <h2>Login Options:</h2>
        <hr>
        <br>
        <a :href="casURL" style="width: 190px; margin: auto; display: block; text-decoration: none; margin-bottom: 10px;">
            <div style="padding: 5px; padding-bottom: 5px; border: 1px solid #ccc; border-radius: 6px; background-color: #57068c; width: 190px; color: white;">
                Sign in with 
                <br>
                <img src="/img/nyu_logo_white.png" width="80" style="margin: 8px"/>
            </div>
        </a>
        <!--<a :href="casURL">
            <img src="/img/som_logo_purple.png" height="50" width="190"  style="padding: 3px; padding-bottom: 5px; border: 1px solid #ccc; border-radius: 10px"/>
        </a>-->
        <div v-if="showGoogleLogin">
            <a :href="$store.state.api_url + '/api/auth/google'">
                <img src="/img/google_login.png" />
            </a>
            <br><br>
        </div>
    </center>
</template>

<script>
    export default {
        data() {
            return {
                showGoogleLogin: true,
            }
        },
        computed: {
            casURL: function(){
                var urlParams = this.$route.query
                var casURL = this.$store.state.api_url + '/api/auth/cas'
                if(urlParams.source){
                    casURL += "?source=" + encodeURIComponent(urlParams.source)
                }
                return casURL
            }
        }
    }
</script>
